import { ApolloLink, NextLink, Operation } from '@apollo/client'

export const AUTH_TOKEN_HEADER = 'Authorization'
const AUTH_TOKEN_STORAGE_KEY = 'authToken'

// The backend rejects requests carrying an invalid Bearer token even when a
// valid session cookie is present, so sign-in operations must stay header-free
const OPERATIONS_WITHOUT_AUTH_TOKEN = ['signInUser', 'signInThirdPartyUser']

export const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_STORAGE_KEY)

export const setAuthToken = (token: string) => localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token)

export const clearAuthToken = () => localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY)

class AuthTokenLink extends ApolloLink {
  request(operation: Operation, forward: NextLink) {
    operation.setContext((context: Record<string, any>) => {
      const { headers = {} } = context
      const token = getAuthToken()
      if (token && !OPERATIONS_WITHOUT_AUTH_TOKEN.includes(operation.operationName)) {
        headers[AUTH_TOKEN_HEADER] = `Bearer ${token}`
      }

      return {
        headers
      }
    })
    return forward(operation)
  }
}

export const authTokenLink = new AuthTokenLink()
